<template>
  <div class="service">
    <div v-html="agree"></div>
  </div>
</template>

<script>
import { syncLocaleFromUrl, onLocaleChange } from '@/utils/lang'

export default {
  name: 'service',
  data(){
    return{
      agree:null
    }
  },
  watch: {
    '$route.query.lang' () {
      this.syncLangAndLoad()
    }
  },
  created () {
    this._offLocaleChange = onLocaleChange(() => {
      this.getAgree()
    })
    this.syncLangAndLoad()
  },
  beforeDestroy () {
    if (this._offLocaleChange) {
      this._offLocaleChange()
    }
  },
  methods:{
    syncLangAndLoad () {
      syncLocaleFromUrl(this.$i18n, this.$route.query)
      this.getAgree()
    },
    getAgree(){
      this.$http.get('/api/getAgreement?type=3').then((res) => {
        this.agree = res.data.data.content
      })
    }
  }
}
</script>

<style scoped lang="less">
.service {
  width: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;

  div {
    margin-top: 10%;
    margin-bottom: 20%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/service.vue